import { Component } from '@angular/core';
import { LanguageSelectorComponent } from '../../components/language-selector/language-selector.component';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-case-fmh-dialog',
  templateUrl: './case-fmh-dialog.component.html',
  styleUrls: ['./case-fmh-dialog.component.scss'],
  imports: [LanguageSelectorComponent, MatButton, TranslateModule],
})
export class CaseFmhDialogComponent {}
